module.exports = __webpack_public_path__ + "img/pos-img1.8c7725dc.png";